module.exports = __webpack_public_path__ + "static/media/lu_ruleta.3bef600a.png";